'use client'

import React from 'react'

import { IVatStatusContext, VatStatusContext } from './VatStatusContext'
import { VAT_STATUS } from '../price-context/VAT_STATUS'

export const VatStatusProvider = ({
  children,
  initialVatStatus,
}: {
  children: React.ReactNode
  initialVatStatus: VAT_STATUS
}) => {
  const [vatStatus, setVatStatus] = React.useState<VAT_STATUS>(initialVatStatus)
  const context: IVatStatusContext = {
    vatStatus,
    setVatStatus,
  }

  return (
    <VatStatusContext.Provider value={context}>
      {children}
    </VatStatusContext.Provider>
  )
}
